import { z } from 'my-zod'
import { v4 as uuid } from 'uuid'
import { TimeZoneEnum } from '../../internal/timezone'

export const operatorAddressFragment = z.object({
  id: z
    .string()
    .uuid()
    .initFn(() => uuid()),
  attention: z.string().uuid().nullish(),
  addressLine1: z.string().setLabel('Address Line 1'),
  addressLine2: z.string().nullish().setLabel('Address Line 2'),
  city: z.string().setLabel('City'),
  postalCode: z.string().setLabel('Postal Code'),
  stateProvince: z.string().setLabel('State/Province'),
  country: z.string().setLabel('Country'),
  notes: z.string().nullish().setLabel('Notes'),
  timezone: TimeZoneEnum.nullable().setLabel('Time zone'),
  webDescription: z.string().max(200).nullish().setLabel('Description')
})

export type operatorAddressFragment = z.infer<typeof operatorAddressFragment>
